import React, {useEffect, useState} from 'react'
import parseToken from "../../../../../../helpers/parseToken"
import {getListTenantShortPhone} from "../../../../../../services/api/apiCustomerHub"
import {message, Spin} from "antd"
import VirtualNumberModal from "./VirtualNumberModal"
import TransferShortPhoneModal from "./TransferShortPhoneModal"
import _checkRoles from "../../../../../../helpers/checkRole"

const VirtualNumberManagement = (props) => {
  const allowAction = _checkRoles('menu.customerhub.shortPhone')
  const allowTransfer = _checkRoles('menu.customerhub.editCustomer.mv.shortphone')
  const {custId} = props
  const decodeToken = parseToken()
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [listVirtualNumber, setListVirtualNumber] = useState([])
  const [selectItem, setSelectItem] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  const [isOpenTransfer, setIsOpenTransfer] = useState(false)
  const [transferShortPhone, setTransferShortPhone] = useState('')

  const _onOpenModal = () => {
    setIsOpen(true)
  }

  const _closeModal = () => {
    setIsOpen(false)
  }

  const _onAddVirtualNumber = () => {
    _onOpenModal()
    setIsEdit(false)
  }

  const _editSelectVirtualPhone = (dataItem) => {
    setIsEdit(true)
    _onOpenModal()
    setSelectItem(dataItem)
  }

  const _fetchListVirtualNumbers = async () => {
    setLoading(true)
    try {
      const response = await getListTenantShortPhone(decodeToken.sub, custId)

      setLoading(false)

      const {success, data, error_message} = response

      if (parseInt(success) !== 1) {
        return message.error(error_message)
      }

      setListVirtualNumber(data)
    } catch (e) {
      setLoading(false)
      message.error(e.message)
    }
  }

  useEffect(() => {
    _fetchListVirtualNumbers()
    // eslint-disable-next-line
  }, []);

  return (
    <div className="BlockCenter">
      <div className="headerBlock d-flex align-items-start justify-content-between">
        <h3>Quản lý số ảo</h3>
      </div>
      <div className="ContentPage">
        <div className="CustomersTable">
          <Spin spinning={loading} tip='Đang lấy dữ liệu...'>
            <table>
              <thead className="CustomersHead">
              <tr>
                <th>Số ảo</th>
                <th>IP đón cuộc gọi vào</th>
                <th>Danh sách IP gọi ra</th>
                <th className="Actions"/>
              </tr>
              </thead>
              <tbody className="CustomersBody">
              {
                listVirtualNumber.map(item => {
                  return (
                    <tr className="CustomersItem" key={item.id}>
                      <td>{item.shortPhone}</td>
                      <td>{item.ipIn}</td>
                      <td>
                        {item?.ipOut.split(',').map(item => {
                          return <div>{item}</div>
                        })}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          {allowAction && <span
                            style={{fontSize: '18px'}}
                            className="material-icons cursor-pointer text-primary"
                            onClick={() => _editSelectVirtualPhone(item)}
                          >border_color</span>}
                          {allowTransfer && <span
                            style={{fontSize: '26px', marginLeft: '8px'}}
                            className="material-icons cursor-pointer text-primary"
                            title="Chuyển cụm"
                            onClick={() => {
                              setTransferShortPhone(item.shortPhone)
                              setIsOpenTransfer(true)
                            }}
                          >swap_horiz</span>}
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </Spin>
          <div className="action-add-phone">
            {
              allowAction && <span className="material-icons cursor-pointer text-primary"
                                   onClick={_onAddVirtualNumber}>add</span>
            }
          </div>
        </div>
      </div>

      {isOpen && <VirtualNumberModal
        tenantId={custId}
        isEdit={isEdit}
        selectItem={selectItem}
        isOpen={isOpen}
        onClose={_closeModal}
        onGetAgain={_fetchListVirtualNumbers}
      />}

      {isOpenTransfer && <TransferShortPhoneModal
        visible={isOpenTransfer}
        onClose={() => setIsOpenTransfer(false)}
        shortPhone={transferShortPhone}
        onGetAgain={_fetchListVirtualNumbers}
      />}
    </div>
  )
}

export default VirtualNumberManagement
